import React from 'react';
import { Row, Col, Label } from "reactstrap";

export default class ContainersDetalhesDUE extends React.Component {

    constructor(props) {
        super(props);
    }

    renderLista = () => {
        let listaDadosDue = this.props.listaDados;
        // if (this.props.listaDados && this.props.listaDados.length > 0)
        //    dadosDue = this.props.listaDados[0];
        return ( <div className="containers-detalhes">   
                    {this.props.dadosContainer.Subcategoria.toUpperCase() !== "CABOTAGEM" ? <h2 className="p-0 m-0 mb-2">DUE</h2> : <div className="p-0 m-0 mb-2" />}
                    { listaDadosDue &&  listaDadosDue.length > 0 ?
                            listaDadosDue.map((dadosDue, i) => {
                                    return      <React.Fragment>
                                                {i % 2 != 0 ? <hr /> : ""}
                                                <Row className={`background-white`}>
                                                        <Col className="containers-detalhes-col-status">
                                                            <Row>
                                                                <Col className="containers-detalhes-col-status">
                                                                    <Label className="label-disabled">SITUAÇÃO</Label>
                                                                    {<span className="situacao-btn ok"> {dadosDue.Mensagem ? dadosDue.Mensagem : "---"} </span>}
                                                                </Col>
                                                            </Row>
                                                        </Col>
                                                        <Col xs={6} sm={4} className="containers-detalhes-col">
                                                            <Row>
                                                                <Col>
                                                                    <Label className="label-disabled">DUE NFTC</Label>
                                                                </Col>
                                                            </Row>
                                                            <Row>
                                                                <Col>
                                                                    <Label className="label-secondary">{dadosDue.StatusNftcDsc ? dadosDue.StatusNftcDsc : "---"}</Label>
                                                                </Col>
                                                            </Row>
                                                        </Col>
                                                        <Col xs={6} sm={4} className="containers-detalhes-col">
                                                            <Row>
                                                                <Col>
                                                                    <Label className="label-disabled">ÚLTIMO ENVIO</Label>
                                                                </Col>
                                                            </Row>
                                                            <Row>
                                                                <Col>
                                                                    <Label className="label-secondary">{dadosDue.DataEnvio ? dadosDue.DataEnvio : "---"}</Label>
                                                                </Col>
                                                            </Row>
                                                        </Col>
                                                        <Col xs={6} sm={4} className="containers-detalhes-col">
                                                            <Row>
                                                                <Col>
                                                                    <Label className="label-disabled">RETORNO RECEITA</Label>
                                                                </Col>
                                                            </Row>
                                                            <Row>
                                                                <Col>
                                                                    <Label className="label-secondary">{dadosDue.StatusCodeDsc ? dadosDue.StatusCodeDsc : "---"}</Label>
                                                                </Col>
                                                            </Row>
                                                        </Col>
                                                        <Col xs={6} sm={4} className="containers-detalhes-col">
                                                            <Row>
                                                                <Col>
                                                                    <Label className="label-disabled">NÚMERO NFE</Label>
                                                                </Col>
                                                            </Row>
                                                            <Row>
                                                                <Col>
                                                                    <Label className="label-secondary">{dadosDue.NotaFiscalTranspNum ? dadosDue.NotaFiscalTranspNum : "---"}</Label>
                                                                </Col>
                                                            </Row>
                                                        </Col>
                                                        <Col xs={6} sm={4} className="containers-detalhes-col">
                                                            <Row>
                                                                <Col>
                                                                    <Label className="label-disabled">SÉRIE NFE</Label>
                                                                </Col>
                                                            </Row>
                                                            <Row>
                                                                <Col>
                                                                    <Label className="label-secondary">{dadosDue.NotaFiscalTranspSerie ? dadosDue.NotaFiscalTranspSerie : "---"}</Label>
                                                                </Col>
                                                            </Row>
                                                        </Col>
                                                        <Col xs={6} sm={4} className="containers-detalhes-col">
                                                            <Row>
                                                                <Col>
                                                                    <Label className="label-disabled">DATA EMISSÃO</Label>
                                                                </Col>
                                                            </Row>
                                                            <Row>
                                                                <Col>
                                                                    <Label className="label-secondary">{dadosDue.DatEmissao ? dadosDue.DatEmissao : "---"}</Label>
                                                                </Col>
                                                            </Row>
                                                        </Col>
                                                        <Col xs={"auto"} className="containers-detalhes-col">
                                                            <Row>
                                                                <Col>
                                                                    <Label className="label-disabled">CHAVE NFE</Label>
                                                                </Col>
                                                            </Row>
                                                            <Row>
                                                                <Col>
                                                                    <Label className="label-secondary">{dadosDue.NotaFiscalTranspChave ? dadosDue.NotaFiscalTranspChave : "---"}</Label>
                                                                </Col>
                                                            </Row>
                                                        </Col>    
                                                </Row>
                                                </React.Fragment>
                                    })
                        :
                        <div />}
        </div>);        
    }
    render() {
        return this.renderLista()
    }
}



// WEBPACK FOOTER //
// ./src/modules/consultas/containers/components/ContainersDetalhesDUE.js